module.exports = __webpack_public_path__ + "static/media/caros-bold.efbbc9f7.woff";